import {QA_ROLES,ADMIN_ROLES } from "../constant";

export const redirectToDashboard = (role, navigate) => {
  switch (role) {
    case ADMIN_ROLES.includes(role):
      navigate("/admin-dashboard");
      break;
    case QA_ROLES.includes(role):
      navigate("/qa-dashboard");
      break;
    default:
      navigate("/login");
  }
};
